import axios from 'axios';

const BASE = process.env.REACT_APP_BASE_URL;

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

// super_admin only. Pass projectPid to scope to one project (see
// docs/phone-mapping-list-by-project-api-request.md) — omit for the org-wide list.
export const listPhoneMappings = (projectPid) => {
  const params = projectPid ? { projectPid } : {};
  return axios.get(`${BASE}/api/v1/telephony/admin/phone-mappings`, { params, headers: authHeaders() });
};

export const createPhoneMapping = (projectPid, phoneNumber) =>
  axios.post(`${BASE}/api/v1/telephony/admin/phone-mappings`, { projectPid, phoneNumber }, { headers: authHeaders() });

export const updatePhoneMapping = (mappingPid, payload) =>
  axios.put(`${BASE}/api/v1/telephony/admin/phone-mappings/${mappingPid}`, payload, { headers: authHeaders() });

export const deletePhoneMapping = (mappingPid) =>
  axios.delete(`${BASE}/api/v1/telephony/admin/phone-mappings/${mappingPid}`, { headers: authHeaders() });
